export default __webpack_public_path__ + "static/media/hayden.026de270.png";